import { render } from "./AppProductReviews.vue?vue&type=template&id=e6dc2448&scoped=true"
import script from "./AppProductReviews.vue?vue&type=script&lang=js"
export * from "./AppProductReviews.vue?vue&type=script&lang=js"

import "./AppProductReviews.vue?vue&type=style&index=0&id=e6dc2448&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6dc2448"]])

export default __exports__